import { SlideHeader } from 'components/Shared';
import { StackedArea, useStackableBreadcrumbs, useStackableContent, } from 'components/Shared/StackedContent/StackableContentContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { breadcrumbUtils } from 'utils';
import { ProductJourneyPages } from '../pages';
import DetailedClaimSlide from './DetailedClaimSlide';
import ImpactClaimSlideContent from './ImpactClaimSlideContent';
const MobileImpactClaimsSlide = ({ mobile, activity, }) => {
    const { t } = useTranslation();
    const { activateStackedContent } = useStackableContent();
    const breadcrumbs = useStackableBreadcrumbs();
    const handleOpenImpactClaimSlide = (claimId) => {
        var _a, _b;
        const selectedClaim = (_b = (_a = activity === null || activity === void 0 ? void 0 : activity.impactClaims) === null || _a === void 0 ? void 0 : _a.edges.find((claim) => claim.node.id === claimId)) === null || _b === void 0 ? void 0 : _b.node;
        activateStackedContent({
            id: ProductJourneyPages.IMPACT_CLAIM,
            area: StackedArea.PAGE,
            breadcrumb: breadcrumbUtils.getBreadcrumb(ProductJourneyPages.IMPACT_CLAIM, t, selectedClaim === null || selectedClaim === void 0 ? void 0 : selectedClaim.impactCatalogItem.title),
            renderComponent: () => (React.createElement(DetailedClaimSlide, { key: ProductJourneyPages.IMPACT_CLAIM, mobile: mobile, impactClaim: selectedClaim, activity: activity })),
            isActive: true,
            layout: {
                hasBackButton: true,
                hasHeader: true,
                hasHeaderScrollEffect: false,
                hasFooter: true,
            },
        });
    };
    return (React.createElement("div", null,
        React.createElement(SlideHeader, { mobile: mobile, breadcrumbs: breadcrumbs, labelBackLink: t('back-to-location'), backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY } }),
        React.createElement(ImpactClaimSlideContent, { detailNode: activity, onClaimClick: handleOpenImpactClaimSlide })));
};
export default MobileImpactClaimsSlide;
